import IconInfo from '@apollo/icons/default/IconInfo.svg';
import {
  Card,
  CardBody,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export type CardWithHeaderProps = {
  title: 'Operation Signature' | 'Query Plan' | string;
  subTitle?: string;
  buttonsArray?: React.ReactElement;
  cardContent: React.ReactElement;
  titleTooltip?: React.ReactElement | string;
  className?: string;
};

export const CardWithHeader = ({
  title,
  subTitle,
  buttonsArray,
  cardContent,
  titleTooltip,
  className,
}: CardWithHeaderProps) => (
  <Card isDivided className={classnames('w-full', className)}>
    <CardHeader>
      <CardTitle>
        {title}
        {titleTooltip ? (
          <Tooltip className="font-normal" label={titleTooltip} interactive>
            <IconInfo className="ml-2 text-secondary" />
          </Tooltip>
        ) : null}
      </CardTitle>
      <CardDescription className="text-clip text-secondary">
        {subTitle || ''}
      </CardDescription>
      {buttonsArray || null}
    </CardHeader>
    <CardBody
      className={classnames(
        'hide-scrollbar max-h-[400px] min-h-[120px] overflow-scroll rounded-b',
      )}
    >
      {cardContent}
    </CardBody>
  </Card>
);
